import React, { Fragment, useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import { useHistory } from "react-router-dom";
import clsx from "clsx";
import Input from "./Input";
import fetcher from "../../services/fetcher";
import Dropdown from "./Dropdown";
import InputDate from "./InputDate";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DadesTecniques from "./DadesTecniques";
import CustomModalSetting from "./CustomModalSetting";
import { useTranslation } from "react-i18next";
import ImatgesComponent from "../CustomInstallacio/ImatgesComponent";
import { fetchRelatedCards } from "../../utils";
import AppContext from "../../context";
import DynamicFormGroups from "../DynamicForm/RelatedCards/DynamicFormGroups";
import { CUSTOM_PAGES_INFO } from "../../config";
import DynamicFormInput from "../DynamicForm/DynamicFormInput";

// const activeTab = 2;

const DynamicInputsWrapper = ({ children }) => (
  <div className="w-100 row">{children}</div>
);

const EditElement = (props) => {
  const { id, config, onSubmit, dadesTecniques, basicInfo, noEditable } = props;

  const [inputs, setInputs] = useState(false);
  const [allOptions, setAlloptions] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [isSettingOpen, setIsSettingOpen] = useState(false);
  const [formData, setFormData] = useState();
  const [documentationConfig, setDocumentationConfig] = useState();
  const { config: { routes } = {} } = useContext(AppContext);
  const [suplementary, setSuplementary] = useState(false);

  const [activeTab, setActiveTab] = useState(1);
  const history = useHistory();
  const [t] = useTranslation("app");
  const tabs = [
    {
      id: 1,
      name: t("generalInformation"),
    },
    {
      id: 3,
      name: t("documentation"),
    },
    {
      id: 4,
      name: t("pictures"),
    },
  ];

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  useEffect(() => {
    handleSetOptions();
    handleFetchData();
    handleRelatedData();
    // tecniquesFields();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRelatedData = async () => {
    const groupedData = await fetchRelatedCards(config, basicInfo, routes);
    const [firstGroup] = groupedData;
    const docConfig = firstGroup.tabs.find(
      (item) => item.originConfig.endpoints.id === "wiki-elements"
    );
    if (docConfig)
      setDocumentationConfig([{ ...firstGroup, tabs: [docConfig] }]);
  };
  const handleChange = ({ target: { value, name } }) =>
    updateInputState(name, value);
  const handleInputchange = ({ currentTarget }) => {
    const { name, value } = currentTarget;
    updateInputState(name, value);
  };

  const getFields = () => {
    if (!config) return [];
    return config.fields || [];
  };

  const handleFetchData = async () => {
    const response = await fetcher({
      path: `${CUSTOM_PAGES_INFO.element.endpoint}${id}/`,
    });
    if (!response) return;
    const fields = getFields();
    let values = {};
    for (const f of fields) {
      values = {
        ...values,
        [f.name]: response[f.name],
      };
    }
    setInputs(values);
    setFormData(response);
  };

  const handleSetOptions = async () => {
    const fields = getFields();
    const selectFields = fields.filter((f) => f.type === "select");
    let opt = {};
    for (const f of selectFields) {
      const { endpoint } = f.options;
      const optData = await fetcher({ path: endpoint });
      if (Array.isArray(optData)) {
        const optionsFormated = optData.map((o) => ({
          label: o.name,
          value: o.pk,
        }));
        opt = {
          ...opt,
          [f.name]: optionsFormated,
        };
      }
    }
    setAlloptions(opt);
  };

  const updateInputState = (name, value) => {
    setInputs((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleDropdownChange = ({ currentTarget }) => {
    const { name, value } = currentTarget;
    updateInputState(name, parseInt(value));
  };

  const handleSubmit = () => {
    suplementary ? onSubmit(formData) : onSubmit(inputs);
  };

  const handleCancel = () => {
    onSubmit({});
  };

  const renderFields = () => {
    const fields = getFields();
    return fields.map((f, index) => {
      const value = inputs[f.name];
      const options = allOptions[f.name];
      switch (f.type) {
        case "text":
          return (
            <Col md="6" key={index}>
              <Input
                isEdit={isEdit}
                id={f.name}
                label={f.label}
                name={f.name}
                value={value}
                onChange={handleInputchange}
                required={f.required}
                disabled={!f.editable || !isEdit}
              />
            </Col>
          );
        case "select":
          return (
            <Col md="6" key={index}>
              <Dropdown
                classNameSelect="FitxaElement-select"
                isEdit={isEdit}
                label={f.label}
                name={f.name}
                value={value}
                onChange={handleDropdownChange}
                options={options}
                required={f.required}
                disabled={!f.editable || !isEdit}
              />
            </Col>
          );
        case "textarea":
          return (
            <Col md="6" key={index}>
              <Input
                textAreaType
                id={f.name}
                label={f.label}
                name={f.name}
                value={value}
                onChange={handleInputchange}
                required={f.required}
                disabled={!f.editable || !isEdit}
              />
            </Col>
          );
        case "date":
          return (
            <Col md="6" key={index}>
              <InputDate
                id={f.name}
                label={f.label}
                name={f.name}
                value={value}
                onChange={handleInputchange}
                required={f.required}
                disabled={!f.editable || !isEdit}
                type="date"
              />
            </Col>
          );
        //Here, you can add any dynamic input available in the DynamicFormInput:
        //case '[dynamic-input-name]':
        case "select-async":
          return (
            <Col md="6" key={index}>
              <DynamicFormInput
                type={f.type}
                label={f.label}
                name={f.name}
                onChange={handleChange}
                options={f.options}
                editable={f.editable}
                isEditing={isEdit}
                required={f.required}
                defaultValue={f.defaultValue}
                labelColumn={{
                  md: 5,
                  className:
                    "text-sm-left text-md-right p-0 col-6 font-weight-bold",
                }}
                inputColumn={{ md: 7 }}
                Wrapper={DynamicInputsWrapper}
              />
            </Col>
          );
        default:
          return <Fragment key={index} />;
      }
    });
  };

  // const updateData = (data) => {};

  const toggleMap = () => {
    history.push(`${history.location.pathname}/Map/`, {
      endPointConfig: config.map,
      originData: basicInfo,
    });
  };

  return (
    <Card className="card-box">
      <Row>
        <Col md="12">
          <div className="card-header py-3">
            <div className="card-header--title font-size-lg">
              {basicInfo.form_title || config.name}
              {!noEditable && (
                <Button
                  size="sm"
                  color="dark"
                  className="ml-3"
                  onClick={() => setIsEdit(!isEdit)}
                >
                  <small>
                    <FontAwesomeIcon icon={["fas", "pencil-alt"]} />
                  </small>
                  {/* <span className="btn-wrapper--label">Editar</span> */}
                </Button>
              )}
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col md="3" className="pr-0">
          <Nav
            pills
            className="nav-neutral-primary flex-column p-3 text-black-50"
            tabs
          >
            {tabs.map(({ id, name }) => (
              <NavItem key={id}>
                <NavLink
                  style={{ justifyContent: "space-between" }}
                  onClick={() => toggleTab(id)}
                  className={clsx({ active: activeTab === id }, "d-flex")}
                >
                  <span>{name}</span>
                  {id === 2 && (
                    <span onClick={() => setIsSettingOpen((prev) => !prev)}>
                      <FontAwesomeIcon icon={faCog} />
                    </span>
                  )}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </Col>
        <Col md="9">
          <div className="p-4-5">
            <TabContent className="FitxaElement-info" activeTab={activeTab}>
              <TabPane key={tabs.id} tabId={tabs[0].id}>
                <div className="dynamic-form">
                  <Row>
                    {inputs && renderFields()}
                    <Col md="6">
                      <fieldset className="row form-group">
                        <div className="w-100 row">
                          <div className="text-sm-left text-md-right p-0 col-6 col-md-5">
                            <label
                              htmlFor="form-2-last-name"
                              className="w-100 font-weight-bold"
                            >
                              Mapa
                            </label>
                          </div>
                          <div className="col-6 col-md-7">
                            <button
                              className="btn btn-link"
                              onClick={toggleMap}
                            >
                              <FontAwesomeIcon
                                icon={["fas", "map-marked"]}
                                color="#4293CC"
                                style={{ fontSize: "24px" }}
                              />
                            </button>
                          </div>
                        </div>
                      </fieldset>
                    </Col>

                    <div
                      className="card-header--title font-size-lg mb-3"
                      style={{ "margin-left": "-20px" }}
                    >
                      <u>{t("technical_data")}</u>
                    </div>
                    <DadesTecniques
                      setSuplementary={setSuplementary}
                      dadesTecniques={dadesTecniques}
                      isEdit={isEdit}
                      setFormData={setFormData}
                    />
                  </Row>
                </div>
              </TabPane>
              {isSettingOpen && (
                <CustomModalSetting
                  handleSubmit={onSubmit}
                  setFormData={setFormData}
                  formData={formData}
                />
              )}
              <TabPane key={tabs.id} tabId={tabs[1].id}>
                <div className="row">
                  <div className="col-12">
                    {documentationConfig && (
                      <DynamicFormGroups groupedData={documentationConfig} />
                    )}
                  </div>
                </div>
              </TabPane>
              <TabPane key={tabs.id} tabId={tabs[2].id}>
                <ImatgesComponent
                  options={{ max_images: 3 }}
                  module="element"
                  id={id}
                  disabled={noEditable}
                />
              </TabPane>
            </TabContent>
          </div>
          {isEdit && !basicInfo?.block_form && (
            <>
              <hr />
              <div style={{ display: "flex" }}>
                <div style={{ marginRight: "15px" }} className="mb-4">
                  <Button
                    type="submit"
                    onClick={handleSubmit}
                    className="submitButton"
                  >
                    {t("submit")}
                  </Button>
                </div>
                <div className="mb-4">
                  <Button
                    type="submit"
                    onClick={handleCancel}
                    className="submitButton"
                  >
                    {t("cancel")}
                  </Button>
                </div>
              </div>
            </>
          )}
        </Col>
      </Row>
    </Card>
  );
};

EditElement.defaultProps = {
  onSubmit: () => {},
};

EditElement.propTypes = {
  id: PropTypes.any,
  config: PropTypes.any,
  onSubmit: PropTypes.func,
};

export default EditElement;
